export default __webpack_public_path__ + "static/media/gallery_02.2f6bad1d.jpg";